import { ReactNode } from "react";
import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { SEO } from "@/components/seo/SEO";
import { Footer } from "@/components/layout/Footer";
import { SELLER } from "@/config/legal";

interface LegalPageProps {
  title: string;
  description: string;
  path: string;
  children: ReactNode;
}

export const LegalPage = ({ title, description, path, children }: LegalPageProps) => (
  <div className="min-h-screen flex flex-col bg-background">
    <SEO title={`${title} — ${SELLER.productName}`} description={description} path={path} />
    <header className="border-b">
      <div className="max-w-4xl mx-auto px-4 py-4 flex items-center justify-between">
        <Link to="/" className="font-semibold text-foreground">{SELLER.productName}</Link>
        <Link to="/pricing" className="text-sm text-muted-foreground hover:text-primary">Pricing</Link>
      </div>
    </header>
    <main className="flex-1 max-w-4xl w-full mx-auto px-4 py-8">
      <Card className="p-6 md:p-8">
        <h1 className="text-3xl font-bold mb-2">{title}</h1>
        <p className="text-sm text-muted-foreground mb-8">Last updated: {SELLER.lastUpdated}</p>
        <div className="space-y-6 text-muted-foreground leading-relaxed [&_h2]:text-xl [&_h2]:font-semibold [&_h2]:text-foreground [&_h2]:mb-2 [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-1 [&_a]:text-primary [&_a]:underline">
          {children}
        </div>
      </Card>
    </main>
    <Footer />
  </div>
);
